import "react-toggle/style.css";
import axios from "axios";
import config from "../../app.json";

import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import FieldSelect from "../Fields/FieldSelect";
import AlertComponent from "../AlertComponent";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import AddOrEditMp4Input from "../../Components/AddAndEditChannel/AddOrEditMp4Input";
import AddOrEditRmtpInput from "../../Components/AddAndEditChannel/AddOrEditRmtpInput";
import AddOrEditElementalLinkInput from "../../Components/AddAndEditChannel/AddOrEditElementalLinkInput";
import AddExistingInputs from "./AddExistingInputs";
function AddOrEditInput(props) {
  const {
    handleAddNewElementsInput,
    handleCancelInput,
    currentElement,
    usedInputs = [],
    availableElements = [],
    newInputPage
  } = props;
  const { id } = useParams();
  let location = useLocation();

  const [inputData, setInputData] = useState(currentElement);
  const [inputName, setInputName] = useState(null);
  const [inputTypeSelected, setInputTypeSelected] = useState({});

  //RMTP
  const [applicationName, setApplicationName] = useState(null);
  const [instanceName, setInstanceName] = useState(null);
  const [rtmpLink, setRtmpLink] = useState(null);

  useEffect(() => {
    if (rtmpLink && instanceName && applicationName) {
      let newLink = rtmpLink.split('1935/')?.at(0) + "1935/" + applicationName + "/" + instanceName;
      setRtmpLink(newLink);
    }
  }, [instanceName, applicationName])

  // Check if there's any device
  const [deviceOptions, setDeviceOptions] = useState(null);
  const [existingInputsOptions, setExistingInputsOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("new");

  let navigate = useNavigate();

  const onAddInput = () => {
    navigate("/listingInputs", { replace: false });
  };
  const onAddNewInput = handleAddNewElementsInput
    ? handleAddNewElementsInput
    : onAddInput;

  const loadDevices = async () => {
    await axios
      .post(config.API + "/api/Input/getElementalLinkDevices")
      .then((res) => {
        const data = [...res.data.$values?.map(v => { return { label: v.name, value: v.id } })];
        setDeviceOptions(data);
        if (data.length == 0)
          inputTypeOptions.splice(2, 1);
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const loadInput = async () => {
    await axios
      .post(config.API + "/api/Input/getInput", { id: currentElement?.id ?? id })
      .then((res) => {
        setInputData(res.data);
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const loadExistingInputs = async () => {
    await axios
      .post(config.API + "/api/Input/getAvailableInputsSelect")
      .then((res) => {
        const data = [...res.data.$values];
        const usedInputsIds = usedInputs.map(({ id }) => id);
        const detachedItems = data.filter((x) => !usedInputsIds.includes(x.id));
        const optionsCombo = detachedItems.map((x) => {
          return { value: x, label: `${x.name} (${x.inputType})` };
        });

        setExistingInputsOptions(optionsCombo);
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  const inputTypeOptions = [
    { value: 1, label: "MP4 Input" },
    { value: 2, label: "RMTP Input" },
    { value: 3, label: "Elemental Link Input" },
  ];

  useEffect(() => {
    loadDevices();
  }, [0]);

  useEffect(() => {
    if (deviceOptions != null) {
      // use id only if is at manageInput route
      if (currentElement || (location.pathname?.indexOf("/manageInput/") > -1 && id))
        loadInput();
    }
  }, [deviceOptions]);

  useEffect(() => {
    if (!inputData) {
      loadExistingInputs();
    } else {
      setInputName(inputData.name);
      switch (inputData.inputType) {
        case "MP4":
          setInputTypeSelected(inputTypeOptions[0]);
          break;
        case "RTMP":
          setInputTypeSelected(inputTypeOptions[1]);
          break;
        case "ElementalLink":
          setInputTypeSelected(inputTypeOptions[2]);
          break;
      }
    }
  }, [inputData]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const disableInputName = inputData && inputData.attached;

  const possibleAvailableItems = availableElements.map((x) => {
    return { value: x, label: `${x.name} (${x.inputType})` };
  });
  const possibleInputs = [...existingInputsOptions, ...possibleAvailableItems];
  return (

    <div className={"new-channel-inputs " + (newInputPage ? "mt-4 col-md-6" : "")}>
      <div className="add-new-channel-container">
        <div className="left-item">
          <h3>{`${inputData ? `Editing` : `Adding`} Input`}</h3>
        </div>
        {handleCancelInput && (
          <div className={`right-item`}>
            <Button
              className="small-btn-cancel"
              variant="outline-primary"
              size="sm"
              onClick={handleCancelInput}
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
      {handleCancelInput && possibleInputs && possibleInputs.length > 0 && (
        <div className="cs-radio-select">
          <div className="radio-item">
            <input
              type="radio"
              value="new"
              id="new"
              checked={selectedValue === "new"}
              onChange={handleChange}
            />
            <label for="new">New</label>
          </div>
          <div className="radio-item">
            <input
              type="radio"
              value="existing"
              id="existing"
              checked={selectedValue === "existing"}
              onChange={handleChange}
            />
            <label for="existing">Existing</label>
          </div>

        </div>
      )}
      {selectedValue === "new" && (
        <div>
        <Row>
          <Col md={12}>
            <FieldText
              label="Input Name"
              type="text"
              onChange={(x) => setInputName(x.target.value)}
              placeholder="Input Name"
              value={inputName}
              required={true}
              inputClassName={`inputOption`}
              disabled={disableInputName}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FieldSelect
              label={`Select Input Type`}
              options={inputTypeOptions}
              className={`col-md-12`}
              id={`inputTypeSelected`}
              name={`inputTypeSelected`}
              onChange={setInputTypeSelected}
              value={inputTypeSelected}
              placeholder={`Choose Channel`}
              readonly={inputData}
            />
          </Col>
        </Row>
        </div>
      )}

      {selectedValue === "new" && inputTypeSelected.value === 1 && (
        <AddOrEditMp4Input
          inputName={inputName}
          handleAddNewElementsInput={onAddNewInput}
          currentElement={inputData}
        />
      )}

      {selectedValue === "new" && inputTypeSelected.value === 2 && (
        <AddOrEditRmtpInput
          inputName={inputName}
          instanceName={instanceName}
          setInstanceName={setInstanceName}
          applicationName={applicationName}
          setApplicationName={setApplicationName}
          rtmpLink={rtmpLink}
          setRtmpLink={setRtmpLink}
          handleAddNewElementsInput={onAddNewInput}
          currentElement={inputData}
        />
      )}

      {selectedValue === "new" && inputTypeSelected.value === 3 && (
        <AddOrEditElementalLinkInput
          inputName={inputName}
          handleAddNewElementsInput={onAddNewInput}
          deviceOptions={deviceOptions}
          currentElement={inputData}
        />
      )}

      {possibleInputs &&
        possibleInputs.length > 0 &&
        selectedValue === "existing" && (
          <AddExistingInputs
            handleAddNewElementsInput={onAddNewInput}
            existingInputsOptions={possibleInputs}
          />
        )}
    </div>
  );
}

export default AddOrEditInput;
